import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';

Vue.component('slideshow-carousel-component', {
    data() {
        return {
            swiper: null,
        };
    },

    async mounted() {
        await this.initSwiper();
    },

    methods: {
        async initSwiper() {
            const slider = this.$el.querySelector(
                '.slideshow-carousel__slider',
            );

            if (!slider) {
                return;
            }

            const { Swiper } = await getSwiper();
            const { Pagination } = await getSwiperModules();

            this.swiper = new Swiper(slider, {
                slidesPerView: 5,
                loop: true,
                breakpoints: {
                    240: {
                        slidesPerView: 1,
                    },
                    767: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                    1280: {
                        slidesPerView: 4,
                    },
                    1440: {
                        slidesPerView: 5,
                    },
                },
                modules: [Pagination],
            });
        },

        destroySwiper() {
            this.swiper.destroy();
            this.swiper = null;
        },
    },
});
